import React from 'react';
import T from 'prop-types';

import skeletons from '../../Skeletons';
import Tooltip from '../../../../../Tooltip';
import SimpleCard from '../../../../../Card/SimpleCard';
import ThresholdBadge from '../../../../../ThresholdBadge';
import PerformanceListTooltip from '../../../../../../pages/company-page-v2/components/CompanyPerformance/PerformanceListTooltip';

const normalizeValue = (_value) => {
  const value = _value.toLowerCase();
  if (value === 'above' || value === 'rising') return { aboveLabel: value, value: 1 };
  if (value === 'inline' || value === 'stable') return { inlineLabel: value, value: 0 };
  if (value === 'below' || value === 'declining') return { belowLabel: value, value: -1 };
  return {};
};

const KpiSpotlightQV = ({ kpiSpotlight, settings }) => (
  <SimpleCard
    className="kpi-spotlight-qv"
    headerLeft={
      settings.pending ? skeletons.kpiSpotlight.cardTitle : <h4 className="h4">KPI Spotlight</h4>
    }
  >
    {settings.pending ? (
      skeletons.kpiSpotlight.cardBody
    ) : (
      <>
        <div className="kpi-forecasts-qv__trow">
          <div className="kpi-forecasts-qv__thcell">Entity</div>
          <div className="kpi-forecasts-qv__thcell text-right">KPI</div>
          <div className="kpi-forecasts-qv__thcell text-right">
            {kpiSpotlight?.[0]?.correlation_date} Read
          </div>
        </div>
        {kpiSpotlight.map((item, i) => (
          <div key={i} className="kpi-forecasts-qv__trow">
            <PerformanceListTooltip
              title="Entities"
              list={item.entity_uids?.map((uid) => ({ label: item.entity_names[uid] }))}
            >
              <p className="text-truncate text-bold text-blue text-underline">
                {item.entity_uids?.map((uid) => item.entity_names[uid]).join(', ')}
              </p>
            </PerformanceListTooltip>
            <div className="kpi-forecasts-qv__tdcell">
              <Tooltip content={item.va_kpi_name}>
                <p className="text-truncate">{item.va_kpi_name}</p>
              </Tooltip>
            </div>
            <div className="kpi-forecasts-qv__tdcell">
              <ThresholdBadge displayMode="label" {...normalizeValue(item.read)} />
            </div>
          </div>
        ))}
      </>
    )}
  </SimpleCard>
);

KpiSpotlightQV.propTypes = {
  kpiSpotlight: T.array,
  settings: T.object.isRequired,
};

export default KpiSpotlightQV;
